// Domain-based app mode detection
// Each department gets its own domain showing only their section.
// Hostnames must stay in sync with ALLOWED_ORIGINS in supabase/functions/_shared/cors.ts.
// `shortTitle` is the compact header title on phones and the login subtitle.

export const BRAND_NAME = 'Ready Made Frames';

const DOMAIN_MAP = {
  'picking-software.ultimatframes.com': {
    mode: 'orders',
    title: 'Picking Portal',
    shortTitle: 'Order Picking',
    description: 'Pick and pack readymade frames',
    defaultRoute: '/orders',
  },
  'stocktake-software.ultimatframes.com': {
    mode: 'stock-take',
    title: 'Stock Take Portal',
    shortTitle: 'Stock Take',
    description: 'Inventory counting and adjustments',
    defaultRoute: '/stock-take',
  },
  'workorders-software.ultimatframes.com': {
    mode: 'work-orders',
    title: 'Work Orders Portal',
    shortTitle: 'Work Orders',
    description: 'Production work order reporting',
    defaultRoute: '/work-orders',
  },
};

const FULL_MODE = {
  mode: 'full',
  title: 'Ready Made Frames Dispatch Portal',
  shortTitle: 'Dispatch Portal',
  description: 'A tool for picking and packing readymade frames',
  defaultRoute: '/orders',
};

export function getDomainConfig() {
  const hostname = window.location.hostname;
  return DOMAIN_MAP[hostname] || FULL_MODE;
}
